import { render } from "./personalCollect.vue?vue&type=template&id=6b21dc53&scoped=true"
import script from "./personalCollect.vue?vue&type=script&lang=js"
export * from "./personalCollect.vue?vue&type=script&lang=js"

import "../../forum/css/antd.css?vue&type=style&index=0&lang=css"
import "./personalCollect.vue?vue&type=style&index=1&id=6b21dc53&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b21dc53"]])

export default __exports__